import { DateTime } from 'luxon';
import { Loading } from '@library/components/Loading';
import { NoResults } from '@library/components/NoResults';
import type { NormalizedProjectionWithPlayer } from '@library/types/streaks';
import { StreakAddProjectionRow } from '@bo-components/streak/StreakAddProjectionRow';
import { classNames } from '@library/utils';

export interface StreakUpcomingProjectionsProps {
  unrankedProjections?: NormalizedProjectionWithPlayer[];
  unrankedProjectionsLoading: boolean;
  onRankProjection: (projection: NormalizedProjectionWithPlayer) => void;
}

export const StreakUpcomingProjections = ({
  unrankedProjections = [],
  unrankedProjectionsLoading,
  onRankProjection
}: StreakUpcomingProjectionsProps) => {
  return (
    <section
      className={classNames(
        'bg-soFresh-120 border-soFresh-140 flex h-full flex-1 shrink-0 flex-col items-start justify-start gap-6 overflow-scroll rounded-2xl p-4'
      )}
    >
      {unrankedProjectionsLoading ? (
        <Loading loadingMessage="Unranked projections loading" />
      ) : (
        <>
          <h2 className="font-heebo text-soClean-100 flex w-full items-center justify-between gap-4 pt-1 text-base font-semibold leading-4">
            Upcoming Projections
          </h2>
          {unrankedProjections.length > 0 ? (
            unrankedProjections.map((projection) => {
              const normalizedPlayer = projection.player;
              const imageUrl = normalizedPlayer?.attributes.image_url;
              const playerName = normalizedPlayer?.attributes?.name;
              const subheader = `${normalizedPlayer?.attributes.position} • ${normalizedPlayer?.attributes.team_name}`;
              const gameInfo = `${normalizedPlayer?.attributes.team} vs. ${projection.attributes.description} • ${DateTime.fromISO(projection.attributes.start_time).toFormat('t')}`;
              return (
                <StreakAddProjectionRow
                  key={projection.id}
                  imageUrl={imageUrl}
                  name={playerName ?? ''}
                  onAddProjection={() => onRankProjection(projection)}
                  subheader={subheader}
                  statType={projection.attributes.stat_type}
                  lineScore={projection.attributes.line_score}
                  gameInfo={gameInfo}
                />
              );
            })
          ) : (
            <NoResults label="No upcoming projections were found" />
          )}
        </>
      )}
    </section>
  );
};
